import React from "react";
import PropTypes from "prop-types";
import { MasterSidebar } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * Sidebar para lista de memberships (Memberships) do NeoApp
 * Suporta drag and drop via MasterSidebar.
 */
const MembershipSidebar = ({ memberships, activeId, onSelect, onCreateNew, loading }) => {
    const renderItem = (membership, isActive) => (
        <div className="text-start w-100 overflow-hidden">
            <div className="d-flex align-items-center justify-content-between">
                <p className={`mb-0 fw-semibold text-truncate ${isActive ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '13.5px' }}>
                    {membership.name}
                </p>
                {membership.status === GLOBAL_STATUS.INACTIVE && (
                    <i className="mdi mdi-eye-off-outline text-muted" style={{ fontSize: '14px' }} title="Inativo"></i>
                )}
            </div>
            <span className="text-muted small text-truncate d-block mt-1" style={{ fontSize: '11px', opacity: 0.8 }}>
                {membership.type === 'recurrent' ? 'Recorrente' : membership.type === 'fixed' ? 'Fixo' : 'Passe'} • {membership.duration} {membership.durationType === 'monthly' ? 'mês(es)' : membership.durationType === 'yearly' ? 'ano(s)' : membership.durationType === 'classes' ? 'aula(s)' : 'dia(s)'}
            </span>
        </div>
    );

    return (
        <MasterSidebar
            title="Planos"
            subtitle="Configuração de Associação"
            icon="mdi mdi-file-document-outline"
            items={memberships}
            activeId={activeId}
            onSelect={onSelect}
            onCreateNew={onCreateNew}
            renderItem={renderItem}
            loading={loading}
            searchPlaceholder="Buscar plano..."
            loadingMessage="Carregando planos..."
        />
    );
};

MembershipSidebar.propTypes = {
    memberships: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    onReorder: PropTypes.func
};

export default MembershipSidebar;
